import React, { useState } from 'react';
import axios from 'axios';
import { Mail, Phone, MapPin, Send, Loader2, CheckCircle2, Facebook, Instagram, Linkedin, Twitter } from 'lucide-react';
import './contact.css';

const Contacts = () => {
  const [formData, setFormData] = useState({
    name: '',
    contact: '',
    email: '',
    message: '',
  });
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('idle'); // idle, success, error
  const [errorMsg, setErrorMsg] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (status === 'error') setStatus('idle'); // Clear error on typing
  };

  const validate = () => {
    if (!/^[0-9]{10}$/.test(formData.contact)) {
      setErrorMsg('Please enter a valid 10-digit mobile number.');
      return false;
    }
    if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      setErrorMsg('Please enter a valid email address.');
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) {
      setStatus('error');
      return;
    }

    setLoading(true);
    setStatus('idle');

    try {
      await axios.post('http://localhost:5020/sendMail', formData);
      setStatus('success');
      setFormData({ name: '', contact: '', email: '', message: '' });
    } catch (err) {
      console.error("Submission Error:", err);
      setStatus('error');
      // Show specific error from backend if available, otherwise generic
      const serverMsg = err.response?.data?.message || err.response?.data?.error;
      setErrorMsg(serverMsg || 'Something went wrong. Please check your connection or try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='cp-premium-page'>
      <div className='cp-overlay'></div>

      <div className='cp-container'>
        <div className='cp-wrapper'>

          {/* Left Column: Contact Info */}
          <div className='cp-info-section'>
            <div className='cp-info-content'>
              <h2 className='cp-title'>Get in Touch</h2>
              <p className='cp-subtitle'>
                Have questions or want to partner with us? We'd love to hear from you.
                Reach out to our team directly or fill out the form.
              </p>

              <div className='cp-details-list'>
                <div className='cp-detail-item'>
                  <div className='cp-icon-box'><Phone size={20} /></div>
                  <div className='cp-detail-text'>
                    <span className='cp-label'>Phone</span>
                    <span>9866672765</span>
                  </div>
                </div>

                <div className='cp-detail-item'>
                  <div className='cp-icon-box'><Mail size={20} /></div>
                  <div className='cp-detail-text'>
                    <span className='cp-label'>Email</span>
                    <span>amaravathinatural@gmail.com</span>
                  </div>
                </div>

                <div className='cp-detail-item'>
                  <div className='cp-icon-box'><MapPin size={20} /></div>
                  <div className='cp-detail-text'>
                    <span className='cp-label'>Headquarters</span>
                    <span>Amaravathi Naturo Tech pvt ltd, Andhra Pradesh, India</span>
                  </div>
                </div>
              </div>

              <div className="cp-socials">
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="cp-social-icon"><Facebook size={20} /></a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="cp-social-icon"><Instagram size={20} /></a>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="cp-social-icon"><Linkedin size={20} /></a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="cp-social-icon"><Twitter size={20} /></a>
              </div>
            </div>
          </div>

          {/* Right Column: Form */}
          <div className='cp-form-section'>
            <form onSubmit={handleSubmit} className='cp-form'>
              <h3 className='cp-form-title'>Send a Message</h3>

              <div className='cp-input-group'>
                <label>Your Name</label>
                <input
                  type='text'
                  name='name'
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder='John Doe'
                />
              </div>

              <div className='cp-input-group'>
                <label>Contact Number</label>
                <input
                  type='text'
                  name='contact'
                  value={formData.contact}
                  onChange={handleChange}
                  required
                  placeholder='10-digit mobile number'
                />
              </div>

              <div className='cp-input-group'>
                <label>Email Address</label>
                <input
                  type='email'
                  name='email'
                  value={formData.email}
                  onChange={handleChange}
                  placeholder='john@example.com (Optional)'
                />
              </div>

              <div className='cp-input-group'>
                <label>Your Message</label>
                <textarea
                  name='message'
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder='How can we help you?'
                ></textarea>
              </div>

              {status === 'error' && (
                <div className='cp-message error'>{errorMsg}</div>
              )}

              {status === 'success' && (
                <div className='cp-message success'>
                  <CheckCircle2 size={18} /> Message sent successfully!
                </div>
              )}

              <button type='submit' className='cp-submit-btn' disabled={loading || status === 'success'}>
                {loading ? <Loader2 className='cp-spinner' size={20} /> : <>Send Message <Send size={18} className='ml-2' /></>}
              </button>
            </form>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Contacts;
